// extracted by mini-css-extract-plugin
module.exports = {"container":"ShirtDesign_container__3ARIC","columnAux":"ShirtDesign_columnAux__3_2lt"};